export const GET_EVENT_API_KEY_REQUEST = "GET_EVENT_API_KEY_REQUEST";
export const GET_EVENT_API_KEY_SUCCESS = "GET_EVENT_API_KEY_SUCCESS";
export const GET_EVENT_API_KEY_FAILURE = "GET_EVENT_API_KEY_FAILURE";

export const getEventApiKeyRequest = (eventId, apiKeyId) => ({
    type: GET_EVENT_API_KEY_REQUEST,
    params: {
        eventId,
        apiKeyId
    }
})

export const getEventApiKeySuccess = (apiKeyRevision) => ({
    type: GET_EVENT_API_KEY_SUCCESS,
    payload: {
        apiKeyRevision
    }
})

export const getEventApiKeyFailure = (error) => ({
    type: GET_EVENT_API_KEY_FAILURE,
    payload: {
        error
    }
})
